import { isDemoPresentation } from '@/lib/constants'

/**
 * Demo affordance containment (ADR 0006 dec. 5 · ADR 0015 dec. 9).
 *
 * The demo world never mutates: every write is theatrically mocked, so a
 * "Save" that succeeds and then reverts on refetch reads as a bug to a
 * prospect. Create/edit/delete/setup affordances therefore hide behind this
 * flag. **Run stays** — running an Action or Playbook (and answering a
 * human-decision prompt) is the demo's whole point and is session-stateful.
 *
 * Deliberately a named alias of `isDemoPresentation` rather than an inline
 * `isDemoPresentation &&` sprinkle: the gates are a set (~15 call sites across
 * six features) and they must stay greppable as a set, the same way
 * `HasRole`/`HasActiveAnalyst` keep the role gates greppable. Use it directly
 * when the gate is a `disabled` prop or a non-render decision; use
 * `components/demo-hidden` when it's a JSX subtree.
 *
 * Route-level containment is a different lever — see `excluded-routes.ts`.
 */
export const isDemoAffordanceHidden = isDemoPresentation
